/* src/app/quoting/pages/quote-new/quote-new.component.scss */
/*# sourceMappingURL=quote-new.component.css.map */
